import {HttpService} from "../../../App/services/http";
import {IFilter} from "../../../App/interfaces/filter";

const items = (filter: IFilter) => {
  return HttpService.get("/management/positions", filter)
    .then(response => {
      return response
    })
}

const position = (id: number) => {
  return HttpService.get(`/management/position/${id}`)
    .then(response => {
      return response
    })
}

const create = (data: FormData) => {
  return HttpService.post(`/management/position`, data, true, true)
    .then(response => {
      return response
    })
}

const update = (id: number, data: FormData) => {
  return HttpService.post(`/management/position/${id}`, data, true, true)
    .then(response => {
      return response
    })
}

const remove = (id: number) => {
  return HttpService.delete(`/management/position/${id}`)
    .then(response => {
      return response
    })
}

export const PositionServices = {
  items,
  position,
  create,
  update,
  delete: remove
}